
            const data = {"name":"money-note","data":{"viewBox":"0 0 512 512","data":"<path pid=\"0\" d=\"M448 85H21v299h427zM171 341 64 235V128h235l106 107v106zm128-106c0 35-29 64-64 64-36 0-64-29-64-64 0-36 28-64 64-64 35 0 64 28 64 64zm170-64v234H107v43h405V171z\"/>","originalColors":[],"stopColors":[]}}
        
                    module.exports = data
                    